import { useDispatch } from 'react-redux';
import Ajv from 'ajv';
import addFormats from 'ajv-formats';

import { FUEL_TYPES } from 'config/app-config';
import { setConsumption } from 'state/consumption/consumption-slice';
import { setFuelType } from 'state/fuel-type/fuel-type-slice';
import { setSelectedAddress } from 'state/selected-address/selected-address-slice';
import { setPaymentMethod } from 'state/payment-method/payment-method-slice';
import { setPostcode } from 'state/postcode/postcode-slice';
import { setElectricVehicle } from 'state/electric-vehicle/electric-vehicle-slice';
import { setError } from 'state/retrieve-quote/retrieve-quote-slice';
import { SchemaValidationError } from 'errors/SchemaValidationError';
import { getMeterpointDetails } from 'state/meterpoint-validation/meterpoint-validation-thunks';
import { setSuccess as setMeterPoints } from 'state/meter-type/meter-type-slice';
import { actionUrl } from 'config/static-content';
import { setIsDualRate } from 'state/quote/quote-slice';

import emailQuoteResponseSchema from 'api/schemas/email-quote-response-schema.json';

const ajv = new Ajv({ strict: true, allowUnionTypes: true });
addFormats(ajv);

export const usePopulateEmailQuoteJourney = () => {
  const dispatch = useDispatch();

  return async (data) => {
    const isValidData = ajv.validate(emailQuoteResponseSchema, data);

    if (!isValidData) {
      const error = new SchemaValidationError({
        message: `We cannot retrieve your saved quote at this time. Please contact ${actionUrl.support}`,
        payload: data,
        schema: emailQuoteResponseSchema,
        ajvErrors: ajv.errors
      });
      dispatch(setError([error.toJson()]));
      throw error;
    }

    const {
      fuel,
      currentAddress,
      electricityConsumption,
      gasConsumption,
      paymentOption,
      isEconomy7,
      isTOU,
      MPAN,
      MPRN
    } = data;
    const gas = fuel === 'gas' || fuel === 'dual';
    const electricity = fuel === 'electricity' || fuel === 'dual';
    const fuelType = {
      [FUEL_TYPES.ELECTRIC]: electricity,
      [FUEL_TYPES.GAS]: gas
    };
    const consumption = {
      [FUEL_TYPES.ELECTRIC]: electricityConsumption,
      [FUEL_TYPES.GAS]: gasConsumption
    };

    const meterpoints = await dispatch(
      getMeterpointDetails({
        ...(MPAN && { mpan: MPAN }),
        ...(MPRN && { mprn: MPRN })
      })
    );
    dispatch(setPostcode(currentAddress.postcode));
    dispatch(setSelectedAddress(currentAddress));
    dispatch(setMeterPoints(meterpoints));
    dispatch(setFuelType(fuelType));
    dispatch(setConsumption(consumption));
    dispatch(setPaymentMethod(paymentOption));
    dispatch(setIsDualRate(isEconomy7));
    dispatch(setElectricVehicle(isTOU));
  };
};
